import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@application/store/useStore';
import React from 'react';
/**
 * Redirects to the given main route whenever the selected company changes.
 * Usage: useRedirectOnCompanyChange('/people')
 */
export function useRedirectOnCompanyChange(mainRoute) {
    const selectedCompanyId = useAppSelector((state) => state.company.selectedCompanyId);
    const navigate = useNavigate();
    const prevCompanyIdRef = React.useRef(null);
    useEffect(() => {
        const previous = prevCompanyIdRef.current;
        const hasPreviousSelection = !!previous && previous.length > 0;
        const hasCurrentSelection = !!selectedCompanyId && selectedCompanyId.length > 0;
        if (previous !== null) {
            const prevKey = previous.slice().sort().join(',');
            const currKey = selectedCompanyId?.slice().sort().join(',');
            const isInitialHydration = !hasPreviousSelection && hasCurrentSelection;
            // Prevent redirect on first company hydration in a freshly opened tab.
            // Still redirect for explicit company switches after initial load.
            if (!isInitialHydration && prevKey !== currKey) {
                navigate(mainRoute);
            }
        }
        prevCompanyIdRef.current = selectedCompanyId;
    }, [selectedCompanyId, navigate, mainRoute]);
}
